import { useCallback, useState } from "react";
import { AgentDetailSaveScope } from "../../../agentDetail.model";
import { useAgentDetailSave } from "./useAgentDetailSave";

export const useUnsavedChangesGuard = (scope: AgentDetailSaveScope = "all") => {
    const [pendingNavigation, setPendingNavigation] = useState<(() => void) | null>(null);
    const { save, isSaving, isDirty, hasErrors, canSave } = useAgentDetailSave(scope);

    const isModalOpen = pendingNavigation !== null;

    const guardNavigation = useCallback(
        (action: () => void) => {
            if (isSaving) return;

            if (isDirty) {
                setPendingNavigation(() => action);
                return;
            }

            action();
        },
        [isDirty, isSaving]
    );

    const handleModalCancel = useCallback(() => {
        setPendingNavigation(null);
    }, []);

    const handleModalSave = useCallback(async () => {
        const success = await save();
        if (!success || !pendingNavigation) return;

        pendingNavigation();
        setPendingNavigation(null);
    }, [save, pendingNavigation]);

    return {
        guardNavigation,
        isModalOpen,
        isSaving,
        isDirty,
        hasErrors,
        canSave,
        handleModalCancel,
        handleModalSave,
    };
};
